import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Themed } from "@components/atoms/Themed"
import { defineBlock } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Shape Links",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/shape-links", (props) => {
  const linkClick = (e: React.MouseEvent) => {
    if (
      e.currentTarget instanceof HTMLAnchorElement &&
      e.currentTarget.href.includes("#") &&
      e.currentTarget.target !== "_blank"
    ) {
      e.preventDefault()
      const id = e.currentTarget.href.split("#")[1]
      const el = document.getElementById(id)
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" })
      }
    }
  }

  return (
    <div className="w-grid mx-auto my-10">
      <div className="w-full grid grid-cols-2 md:grid-cols-11 gap-5">
        <Themed theme="navy" className="col-span-1 md:col-span-3 flex flex-col gap-2">
          <Link
            href={props.link1?.url}
            target={props.link1?.target}
            onClick={linkClick}
            className="w-full h-[35vw] md:h-[18vw] md:max-h-[280px] rounded-xl overflow-hidden themed-bg themed-fg p-7 type-body-xl md:type-title-s"
          >
            {props.link1?.title || (env.admin ? "Link 1" : "")}
          </Link>
        </Themed>
        <Themed theme="whiteLight" className="col-span-1 md:col-span-2 flex flex-col gap-2">
          <div className="w-full h-[35vw] md:h-[18vw] md:max-h-[280px] rounded-full overflow-hidden themed-bg themed-fg">
            {props.image?.mediaItemUrl && !props.video?.mediaItemUrl && (
              <ResponsiveImage
                {...props.image}
                className="w-full h-full object-cover object-center"
                objectFit="cover"
              />
            )}
            {!props.image?.mediaItemUrl && props.video?.mediaItemUrl && (
              <video
                src={props.video.mediaItemUrl}
                className="w-full h-full object-cover object-center"
                playsInline
                autoPlay
                muted
                loop
              />
            )}
          </div>
        </Themed>
        <Themed theme="olive" className="col-span-1 md:col-span-3 flex flex-col gap-2">
          <Link
            href={props.link2?.url}
            target={props.link2?.target}
            onClick={linkClick}
            className="w-full h-[35vw] md:h-[18vw] md:max-h-[280px] rounded-lg overflow-hidden themed-bg themed-fg p-7 type-body-xl md:type-title-s"
          >
            {props.link2?.title || (env.admin ? "Link 2" : "")}
          </Link>
        </Themed>
        <Themed theme="black" className="col-span-1 md:col-span-3 flex flex-col gap-2">
          <Link
            href={props.link3?.url}
            target={props.link3?.target}
            onClick={linkClick}
            className="w-full h-[35vw] md:h-[18vw] md:max-h-[280px] rounded-xl overflow-hidden themed-bg themed-fg p-7 type-body-xl md:type-title-s"
          >
            {props.link3?.title || (env.admin ? "Link 3" : "")}
          </Link>
        </Themed>
      </div>
    </div>
  )
})
